import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

const skillPreviewImage = `${process.env.PUBLIC_URL}/chat-preview.png`;
const dataCaptureSkillImage = `${process.env.PUBLIC_URL}/bot/data-capture-skill.gif`;
const displayListSkillImage = `${process.env.PUBLIC_URL}/bot/display-list-skill.gif`;
const geckoFormSkillImage = `${process.env.PUBLIC_URL}/bot/gecko-form-skill.gif`;
const suggestAnswerSkillImage = `${process.env.PUBLIC_URL}/bot/suggest-answer-skill.gif`;
const workflowSkillImage = `${process.env.PUBLIC_URL}/bot/workflow-skill.gif`;

class SkillPreview extends PureComponent {
  static propTypes = {
    skill_type: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = {
      gifCacheBustKey: Math.random(),
    };
  }

  previewMap = {
    data_capture: {
      label: 'Data Capture Skill Preview',
      image: dataCaptureSkillImage,
    },
    display_list: {
      label: 'Display List Skill Preview',
      image: displayListSkillImage,
    },
    gecko_form: {
      label: 'Gecko Form Skill Preview',
      image: geckoFormSkillImage,
    },
    suggest_answer: {
      label: 'Suggest Answer Skill Preview',
      image: suggestAnswerSkillImage,
    },
    workflow_action: {
      label: 'Workflow Skill Preview',
      image: workflowSkillImage,
    },
    default: {
      label: 'Skill Type Preview',
      image: skillPreviewImage,
    },
  };

  render() {
    const previewData =
      this.previewMap[this.props.skill_type] || this.previewMap['default'];
    return (
      <div className="SkillPreview BotTabEditContainer-section-heading col-12 col-lg-6 col-xl-5">
        <span>{previewData.label}</span>
        <img
          src={
            previewData.image +
            `?gif-cache-busting=${this.state.gifCacheBustKey}`
          }
        />
      </div>
    );
  }
}

export default SkillPreview;
